var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgXlsIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C4.3125 0 3.75 0.5625 3.75 1.25V18.75C3.75 19.4375 4.3125 20 5 20H17.5C18.1875 20 18.75 19.4375 18.75 18.75V5L13.75 0H5Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H18.75L13.75 0V3.75C13.75 4.4375 14.3125 5 15 5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.75L15 5H18.75V8.75Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.25C16.25 16.5938 15.9688 16.875 15.625 16.875H1.875C1.53125 16.875 1.25 16.5938 1.25 16.25V10C1.25 9.65625 1.53125 9.375 1.875 9.375H15.625C15.9688 9.375 16.25 9.65625 16.25 10V16.25Z",
    fill: "#84BD5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6381 12.7419L6.50747 11.6525C6.76747 11.3125 7.27247 11.7469 6.98747 12.0719C6.6881 12.4269 6.3731 12.8119 6.0731 13.2063L7.09247 14.4756C7.36747 14.8506 6.8181 15.21 6.5481 14.84L5.6281 13.6607L4.72372 14.8656C4.46872 15.23 3.90372 14.8207 4.18872 14.4807L5.1931 13.2063C4.8781 12.8113 4.5731 12.4269 4.26872 12.0719C3.95435 11.6969 4.53872 11.3125 4.76872 11.6631L5.6381 12.7419Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70947 11.8419C7.70947 11.6769 7.84947 11.5369 8.02447 11.5369C8.18447 11.5369 8.31947 11.6775 8.31947 11.8419V14.3456H9.67885C10.1682 14.3456 10.1788 15 9.67885 15H8.0251C7.8501 15 7.7101 14.8756 7.7101 14.6956V11.8419H7.70947Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6264 12.2918C10.7414 11.3218 12.2051 11.1475 12.8951 11.6775C13.2351 11.9518 12.8751 12.3868 12.5751 12.1668C12.2051 11.9325 11.3658 11.8225 11.2608 12.3412C11.1258 13.1612 13.2995 12.6918 13.2645 14.0212C13.2295 15.2906 11.3908 15.32 10.7008 14.7506C10.5351 14.6156 10.5408 14.3962 10.6308 14.2606C10.7608 14.1312 10.9051 14.0862 11.0758 14.2262C11.4851 14.5056 12.5401 14.7156 12.6145 14.0056C12.5501 13.2668 10.4714 13.7112 10.6264 12.2918Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.875H3.75V17.5H15.625C15.9688 17.5 16.25 17.2188 16.25 16.875V16.25C16.25 16.5938 15.9688 16.875 15.625 16.875Z",
    fill: "#CAD1D8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXlsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/XLS_Icon.1d52eb5e.svg";
export { ForwardRef as ReactComponent };